import React from 'react'

import Calendar from './calendar/Calendar'
import DailyEmails from './dailyEmails/DailyEmails'
import Materials from './materials/Materials'
import InvoiceItems from './invoiceItems/InvoiceItems'
import CompanyLogo from './companyLogo/CompanyLogo'

export default class General extends React.Component {

  render() {
    return (
      <div>
        <DailyEmails />
        <Calendar style={{ marginTop: 8 }} />
        <Materials style={{ marginTop: 8 }} />
        <InvoiceItems style={{ marginTop: 8 }} />
        <CompanyLogo style={{ marginTop: 8 }}/>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/settings/modules/General.js